export default "__VITE_ASSET__8b6eaf28__"